import React, { Component, Suspense } from "react";
import history from "./components/global/history";
import ga from "./libs/googleAnalyticsConfig";
// Style
import "material-components-web/dist/material-components-web.min.css";
import "./css/index.css";
import "./projects/project-wrapper_styles.css";
// Comps
import HomeTemplate from "./components/templates/HomeTemplate";
import Link from "./components/global/Link";
import { projects } from "./PROJECTS";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { unlisten: null, page: "home" };
  }

  componentDidMount() {
    // set up routing
    const location = history.location;
    const unlisten = history.listen(location => {
      this.setPageData(location.pathname);
    });
    this.setPageData(location.pathname);
    this.setState({ unlisten: unlisten });
  }

  componentWillUnmount() {
    this.state.unlisten();
  }

  setPageData(fullPath) {
    let page;

    if (fullPath === "/") {
      page = "home";
    } else {
      page = fullPath.split("/").join("");
    }

    this.setState({ page });

    ga.set({ page: page });
    ga.pageview(fullPath);
  }

  render() {
    const { page } = this.state;
    const Project = projects.find(exp => exp.url === page);
    const IN_DEV_MODE = false;

    return (
      <div className="App">
        {page === "home" && (
          <HomeTemplate>
            <p>
              The ArtFly lab is a place for me to experiment without breaking
              anything important!
            </p>
            <div className={"app--projectList"}>
              {projects.map(exp => {
                if (!exp.draft || IN_DEV_MODE) {
                  return (
                    <div className={"app--projectSummary"} key={exp.url}>
                      <h2>{exp.title}</h2>
                      <p>{exp.description}</p>

                      <Link to={exp.url} className={"butt"}>
                        {exp.linkText}
                      </Link>
                    </div>
                  );
                } else return null;
              })}
            </div>
          </HomeTemplate>
        )}

        {Project && (
          <Suspense fallback={<div>Loading...</div>}>{Project.comp}</Suspense>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js